'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _components = require('components');

var _datetime = require('helpers/datetime');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectReportFileInfo = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ProjectReportFileInfo, _Component);

  function ProjectReportFileInfo() {
    (0, _classCallCheck3.default)(this, ProjectReportFileInfo);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectReportFileInfo.__proto__ || (0, _getPrototypeOf2.default)(ProjectReportFileInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectReportFileInfo, [{
    key: 'getMessage',
    value: function getMessage(file) {
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_reactI18next.Interpolate, { i18nKey: '{{count}} Plays', count: file.nbPlays }),
        ',',
        _react2.default.createElement(_reactI18next.Interpolate, { className: 'margin-left-10', i18nKey: 'Avge Playtime: {{time}}', time: (0, _datetime.secToMinString)(file.timePlayed) })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var reportData = this.props.reportData;
      var _reportData$averageSt = reportData.averageStat,
          averageStat = _reportData$averageSt === undefined ? [] : _reportData$averageSt,
          _reportData$files = reportData.files,
          files = _reportData$files === undefined ? {} : _reportData$files;


      return _react2.default.createElement(
        'div',
        null,
        averageStat.map(function (file) {
          return _react2.default.createElement(_components.ProjectReportProgressProperty, {
            key: file.uploadId,
            title: files[file.uploadId].filename,
            message: _this2.getMessage(file),
            count: file.nbPlays,
            countAll: reportData.maxPlaysNumber
          });
        })
      );
    }
  }]);
  return ProjectReportFileInfo;
}(_react.Component), _class.propTypes = {
  reportData: _propTypes2.default.object
}, _temp);
exports.default = ProjectReportFileInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectReport/ProjectReportFileInfo.js
// module id = 2054
// module chunks = 1